import { render, staticRenderFns } from "./ClassicBreakdown.vue?vue&type=template&id=1b63a32a&scoped=true"
import script from "./ClassicBreakdown.vue?vue&type=script&lang=js"
export * from "./ClassicBreakdown.vue?vue&type=script&lang=js"
import style0 from "./ClassicBreakdown.vue?vue&type=style&index=0&id=1b63a32a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b63a32a",
  null
  
)

export default component.exports